module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "number-one-lesson-in-life"
    }
  }, [_c('h1', [_vm._v("1. Number One Lesson in Life")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("What you want and what you need are often two very diﬀerent things. Now you say it.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_c('em', [_vm._v("“What I want and what I need are often two very diﬀerent things.”")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Repeat it.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_c('em', [_vm._v("“What I want and what I need are often two very diﬀerent things.”")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Accept it.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("You want to know everything. You don’t need to know at all. The lessons are the point of life.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_c('em', [_vm._v("“Thank you, Universe, for revealing to me what I need to know.”")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("‘Need’ is the keyword. Think of cravings. You want meat; you need iron. You want sugar; you need energy.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 75
// module chunks = 0